import { render, staticRenderFns } from "./CreatePspType.vue?vue&type=template&id=752e56da"
import script from "./CreatePspType.vue?vue&type=script&lang=js"
export * from "./CreatePspType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports